let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("15E48")).then(() => parcelRequire('3vpcy'));